import { useQuery } from '@tanstack/react-query';
import { assistantApi } from './assistantApi';

export const assistantAvailabilityKey = ['assistant', 'availability'] as const;

/**
 * Whether the caller has an assistant: a customer that chooses the model per role gives none to a
 * user whose roles it does not list, whatever their NexoAI.Ask grant. Asked only of a user who may ask.
 */
export function useAssistantAvailability(canAsk: boolean): boolean {
  const { data } = useQuery({
    queryKey: assistantAvailabilityKey,
    queryFn: () => assistantApi.availability(),
    enabled: canAsk,
    staleTime: 5 * 60 * 1000,
  });
  return data?.available === true;
}
